import React from 'react';

export default function FilterBar({ children }) {
  return (
    <div
      style={{
        marginBottom: 16,
        padding: '10px 12px',
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      }}
    >
      {children}
    </div>
  );
}
